import BaseDragLogic, { IMouseDownProps } from './base-drag-logic';

export class PCBaseDragLogic extends BaseDragLogic {
    /**
     * 点击到元素上
     * @param event
     * @param element
     * @param scale
     */
    public handleMouseDownOnElement = (props: IMouseDownProps): void => {
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleDragStop);
        this.startDrag(props);
    };

    /**
     * 拖拽结束
     * @param event
     */
    private handleDragStop = (event: MouseEvent) => {
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleDragStop);
        this.stopDrag(event);
    };

    /**
     * 鼠标移动处理
     * @param event
     */
    private handleMouseMove = (event: MouseEvent) => {
        event.preventDefault();
        const delayTime = 100;
        this.handleMove(event, delayTime);
    };
}
